import { Component, Input } from '@angular/core';
import { User } from 'src/app/models/user';
import { AdminService } from 'src/app/services/admin.service';

@Component({
    selector: '[app-admin-courier-inactive]',
    templateUrl: './admin-courier-inactive.component.html',
    styleUrls: ['./admin-courier-inactive.component.scss']
})
export class AdminCourierInactiveComponent {

    @Input() public courier!: User;

    constructor(
        private adminService: AdminService,
    ) {
    }

    public onActivateClick(): void {
        this.adminService.approveCourier(this.courier.id);
    }
}
